import cx from "classnames";
import { filter, find, get } from "lodash";
import {
  MDBCollapse,
  MDBContainer,
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBListGroup,
  MDBListGroupItem,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBNavItem,
  MDBNavLink
} from "mdbreact";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Button, Image } from "semantic-ui-react";
import VN from "~/assets/img/desktop/HompageClinic/VN.svg";
import fb from "~/assets/img/desktop/HompageClinic/fb.svg";
import helphone from "~/assets/img/desktop/HompageClinic/helphone.svg";
import tiktok from "~/assets/img/desktop/HompageClinic/tiktok.svg";
import youtube from "~/assets/img/desktop/HompageClinic/youtube.svg";
import zalo from "~/assets/img/desktop/HompageClinic/zalo.svg";
import icon_phone from "~/assets/img/desktop/icon/iconphone.svg";
import logo_medpro from "~/assets/img/desktop/icon/logo.svg";
import logo_nhidonghcm from "~/assets/img/desktop/logo/nhidonghcm/logo_header_nhidonghcm.gif";
import Drawer from "~/components/mobile/atoms/Drawer";
import { partnerInfo } from "~/configs/partnerDetails";
import { VERSION_DATE, VERSION_WEB } from "~/configs/version";
import { redirectToMedproId } from "~/store/login/actions";
import { checkReadNoti } from "~/store/notifications/notificationsActions";
import { selectPatientFromList } from "~/store/patient/patientAction";
import { selectMedicalBill } from "~/store/totalData/actions";
import { logOut } from "~/store/user/userAction";
import { getDurationFromNowTo, getNextStepViewNoti } from "~/utils/func";
import { urlLogoHeader } from "~/utils/manageResource";
import partnerId from "~/utils/partner";
import styles from "./style.module.scss";

class Header extends Component {
  state = {
    collapseID: "",
    openMenu: false,
    lastScrollY: 0,
    scrollingDown: false
  };

  notiBell = React.createRef();
  userButton = React.createRef();

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.state.lastScrollY;

    this.setState({
      lastScrollY: currentScrollY,
      scrollingDown
    });
  };

  toggleCollapse = collapseID => () =>
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));

  handleOpenMenu = status => {
    this.setState({ openMenu: status });
  };

  renderSomeNotifications = () => {
    const limit = 3;
    const {
      notification: { data }
    } = this.props;

    if (!data) {
      return <div />;
    }

    // Wait update API noti

    const finData = filter(data, { isRead: false });

    let handleData;
    if (finData.length < 1) {
      handleData = data;
    } else {
      handleData = finData;
    }

    return handleData.slice(0, limit).map((noti, i) => {
      const titleNoti = noti.hospital ? noti.hospital.name : "";

      return (
        <MDBListGroupItem
          key={i}
          className={!noti.isRead ? styles.new : null}
          onClick={() => this.handleViewDetailNoti(noti)}
        >
          <div className={styles.list_news_head}>{titleNoti}</div>
          <p>{noti.title}</p>
          <p>
            <i className="fal fa-clock" />
            {getDurationFromNowTo(noti.createdAt)}
          </p>
        </MDBListGroupItem>
      );
    });
  };

  handleViewDetailNoti = noti => {
    const { history } = this.props;
    this.props.checkReadNoti(noti.id);
    const partnerId = get(noti, "eventData.partnerId", "");
    this.props.selectMedicalBill(partnerId, null);
    const typePaymentNoti = get(noti, "topicId", null);

    if (typePaymentNoti === "exam.result") {
      const patientId = get(noti, "eventData.patientId", null);
      this.props.selectPatientFromList(patientId);
    }

    const url = getNextStepViewNoti(noti);

    if (typePaymentNoti === "bookings.confirm") {
      history.push(url);
    } else if (typePaymentNoti === "invoice.confirm") {
      window.open(url, "_blank") || window.location.replace(url);
    } else {
      history.push(url);
    }
  };

  getActiveClass = pathname => {
    return this.props.location.pathname === pathname
      ? styles.active + " " + styles["active_" + partnerId]
      : styles["itemMenu_" + partnerId];
  };

  render() {
    const { IsAuthenticated, logOut, infoUser, notification } = this.props;
    const { scrollingDown } = this.state;

    const checkUrlClinic = window.location.href.indexOf("/clinic");
    const fullName = get(infoUser, "fullName");
    const userName = get(infoUser, "userName");
    const displayName = fullName !== "" ? fullName : userName;

    const info = get(partnerInfo, "info", "");
    const name = find(info, { key: "name" });

    const menu = get(partnerInfo, "menu");
    const renderMenu = menu.map((item, index) => {
      return (
        <MDBNavItem className={cx(this.getActiveClass(item.url))} key={index}>
          <MDBNavLink
            className=""
            to={item.link}
            replace={this.props.location.pathname === item.link}
          >
            {item.name}
          </MDBNavLink>
        </MDBNavItem>
      );
    });
    return (
      <>
        <MDBContainer fluid className={cx(styles.MenuTop, styles.MenuPartner)}>
          <div className={cx(styles.headerTop, scrollingDown && styles.hidden)}>
            <div className={styles.socialNetwork}>
              <div className={styles.topSocial}>
                <div className={styles.social}>
                  <a
                    href="https://www.tiktok.com/@medprovn/"
                    rel="noopener nofollow noreferrer"
                    target="_blank"
                  >
                    <Image
                      className={styles.iconZalo}
                      src={tiktok}
                      alt="Icon TikTok"
                      width={20}
                      height={20}
                    />
                    <p>TikTok</p>
                  </a>
                </div>
                <div className={styles.social}>
                  <a
                    href="https://www.facebook.com/www.medpro.vn"
                    target="_blank"
                    rel="noopener nofollow noreferrer"
                  >
                    <Image
                      className={styles.iconZalo}
                      src={fb}
                      alt="Icon Facebook"
                      width={20}
                      height={20}
                    />
                    <p>Facebook</p>
                  </a>
                </div>
                <div className={styles.social}>
                  <a
                    href="https://zalo.me/4018184502979486994"
                    target="_blank"
                    rel="noopener nofollow noreferrer"
                  >
                    <Image
                      className={styles.iconZalo}
                      src={zalo}
                      alt="Icon Zalo"
                      width={20}
                      height={20}
                    />
                    <p>Zalo</p>
                  </a>
                </div>
                <div className={styles.social}>
                  <a
                    href="https://www.youtube.com/@medpro-datkhamnhanh"
                    target="_blank"
                    rel="noopener nofollow noreferrer"
                  >
                    <Image
                      className={styles.iconZalo}
                      src={youtube}
                      alt="Icon Youtube"
                      width={20}
                      height={20}
                    />
                    <p>Youtube</p>
                  </a>
                </div>
              </div>
              <div className={styles.downLoad}>
                <Link to="/#download_application">
                  <Button className={styles.btnDownload}>
                    <Image
                      src={helphone}
                      alt="Icon Phone"
                      width={20}
                      height={20}
                    />
                    Tải ứng dụng
                  </Button>
                </Link>
                <div className={styles.language}>
                  <Image src={VN} alt="Icon VietNam" width={20} height={20} />
                  VN
                </div>
              </div>
            </div>
          </div>
          <MDBListGroup
            className={
              checkUrlClinic > -1 ? styles.hidden : styles.list_group_dangnhap
            }
          >
            {/* {IsAuthenticated ? (
              <MDBListGroupItem>
                <MDBDropdown className={styles.mdbropdown}>
                  <MDBDropdownToggle
                    ref={this.notiBell}
                    className={cx(styles.button, styles.bell)}
                  >
                    <i className="fal fa-bell" />
                    {notification.totalNew ? (
                      <span className={styles.count}>
                        {notification.totalNew}
                      </span>
                    ) : null}
                  </MDBDropdownToggle>
                  <MDBDropdownMenu
                    onClick={() => this.notiBell.current.onClick()}
                    right
                    className={cx(
                      styles.mdbdropdownMenu,
                      styles.mdbdropdownBell
                    )}
                  >
                    <div className={styles.head_alert}>
                      <span>Danh sách thông báo</span>
                    </div>
                    <div className={styles.mdbdropdownItem}>
                      <MDBListGroup className={styles.list_news}>
                        {this.renderSomeNotifications()}
                        <MDBListGroupItem>
                          <Link
                            to={{
                              pathname: "/user",
                              state: { activeItem: 3 }
                            }}
                            replace={this.props.location.pathname === "/user"}
                            className={styles.view_all}
                          >
                            <span>Xem tất cả </span>
                          </Link>
                        </MDBListGroupItem>
                      </MDBListGroup>
                    </div>
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBListGroupItem>
            ) : null} */}

            {/* <MDBListGroupItem>
                    <a
                      href="https://umc-v1.medpro.com.vn/"
                      className={cx(styles.button, styles.redirectUMCV1)}
                    >
                      GIAO DIỆN PHIÊN BẢN CŨ
                    </a>
                  </MDBListGroupItem> */}

            {/* <MDBListGroupItem>
                    <Link
                      to={{
                        pathname: "/",
                        state: { scrollToDownload: true }
                      }}
                      replace={this.props.location.pathname === "/"}
                      className={cx(
                        styles.button,
                        styles.downloadApp,
                        styles["downloadApp_" + partnerId]
                      )}
                    >
                      Tải ứng dụng
                    </Link>
                      </MDBListGroupItem> */}

            <div className={styles.customHeader}>
              <div
                className={partnerId === "medpro" ? null : styles.header_brand}
              >
                <a
                  href="https://medpro.vn"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.logoFooter}
                >
                  <img
                    src={logo_medpro}
                    alt="Logo Medpro"
                    className={styles.logoImg}
                  />
                </a>
                <Link to="/" replace={this.props.location.pathname === "/"}>
                  <img
                    src={
                      partnerId === "nhidonghcm"
                        ? logo_nhidonghcm
                        : urlLogoHeader
                    }
                    alt={name.value || "UMC"}
                    className={styles.logoPartner}
                  />
                </Link>
              </div>
              <div className={styles.groupButton}>
                {!IsAuthenticated ? (
                  <>
                    <Button
                      className={cx(styles.button, styles.buttunLogin)}
                      onClick={() => {
                        this.props.redirectToMedproId();
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6666 17.5C16.6666 16.337 16.6666 15.7555 16.5231 15.2824C16.1999 14.217 15.3662 13.3834 14.3009 13.0602C13.8277 12.9167 13.2462 12.9167 12.0832 12.9167H7.91659C6.75362 12.9167 6.17213 12.9167 5.69897 13.0602C4.63363 13.3834 3.79995 14.217 3.47678 15.2824C3.33325 15.7555 3.33325 16.337 3.33325 17.5M13.7499 6.25C13.7499 8.32107 12.071 10 9.99992 10C7.92885 10 6.24992 8.32107 6.24992 6.25C6.24992 4.17893 7.92885 2.5 9.99992 2.5C12.071 2.5 13.7499 4.17893 13.7499 6.25Z"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Đăng nhập
                    </Button>
                  </>
                ) : (
                  <>
                    <MDBListGroupItem>
                      <MDBDropdown className={styles.mdbropdown}>
                        <MDBDropdownToggle
                          ref={this.notiBell}
                          className={cx(styles.button, styles.bell)}
                        >
                          <i className="fal fa-bell" />
                          {notification.totalNew ? (
                            <span className={styles.count}>
                              {notification.totalNew}
                            </span>
                          ) : null}
                        </MDBDropdownToggle>
                        <MDBDropdownMenu
                          onClick={() => this.notiBell.current.onClick()}
                          right
                          className={cx(
                            styles.mdbdropdownMenu,
                            styles.mdbdropdownBell
                          )}
                        >
                          <div className={styles.head_alert}>
                            <span>Danh sách thông báo</span>
                          </div>
                          <div className={styles.mdbdropdownItem}>
                            <MDBListGroup className={styles.list_news}>
                              {this.renderSomeNotifications()}
                              <MDBListGroupItem>
                                <Link
                                  to={{
                                    pathname: "/user",
                                    state: { activeItem: 3 }
                                  }}
                                  replace={
                                    this.props.location.pathname === "/user"
                                  }
                                  className={styles.view_all}
                                >
                                  <span>Xem tất cả </span>
                                </Link>
                              </MDBListGroupItem>
                            </MDBListGroup>
                          </div>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBListGroupItem>
                    <MDBListGroupItem>
                      <MDBDropdown className={styles.mdbropdown}>
                        <MDBDropdownToggle
                          className={cx(styles.buttonUser)}
                          ref={this.userButton}
                        >
                          <Button
                            className={cx(styles.button, styles.after_login)}
                            ref={this.userButton}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.6666 17.5C16.6666 16.337 16.6666 15.7555 16.5231 15.2824C16.1999 14.217 15.3662 13.3834 14.3009 13.0602C13.8277 12.9167 13.2462 12.9167 12.0832 12.9167H7.91659C6.75362 12.9167 6.17213 12.9167 5.69897 13.0602C4.63363 13.3834 3.79995 14.217 3.47678 15.2824C3.33325 15.7555 3.33325 16.337 3.33325 17.5M13.7499 6.25C13.7499 8.32107 12.071 10 9.99992 10C7.92885 10 6.24992 8.32107 6.24992 6.25C6.24992 4.17893 7.92885 2.5 9.99992 2.5C12.071 2.5 13.7499 4.17893 13.7499 6.25Z"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <b>{displayName}</b>
                          </Button>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu
                          onClick={() => this.userButton.current.onClick()}
                          right
                          basic
                          className={cx(
                            styles.mdbdropdownMenu,
                            styles.mdbdropdownProfile
                          )}
                        >
                          <MDBListGroup>
                            <MDBListGroupItem className={styles.item_user}>
                              <div className={styles.item_user_icon}>
                                <i className="fas fa-user-circle" />{" "}
                              </div>
                              <div className={styles.info}>
                                <span>Xin chào!</span>
                                <div className={styles.info_name}>
                                  <b>{displayName}</b>
                                </div>
                              </div>
                            </MDBListGroupItem>
                            <hr className={styles.line} />
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 1 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-address-book" /> Hồ sơ bệnh
                                nhân{" "}
                              </Link>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 2 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-file-medical" /> Phiếu khám
                                bệnh
                              </Link>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 3 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-bell" />
                                Thông báo
                              </Link>
                            </MDBListGroupItem>

                            <MDBListGroupItem className={styles.item_sign_out}>
                              <Link
                                onClick={() => {
                                  logOut();
                                  this.props.history.push("/");
                                }}
                                to="#"
                              >
                                <i className="fal fa-power-off" /> Thoát
                              </Link>
                            </MDBListGroupItem>
                            <hr className={styles.line} />
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <div className={styles.version}>
                                <i>Phiên bản {VERSION_WEB}</i>
                                <i>Mới nhất: {VERSION_DATE}</i>
                              </div>
                            </MDBListGroupItem>
                          </MDBListGroup>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBListGroupItem>
                  </>
                )}
                <a href="tel:19002115">
                  <Button className={cx(styles.button, styles.buttonSupport)}>
                    <img
                      src={icon_phone}
                      alt="phone"
                      className={styles.iconUser}
                    />
                    <div>
                      <p>Hỗ trợ đặt khám</p>
                      <p>19002115</p>
                    </div>
                  </Button>
                </a>
              </div>
            </div>
          </MDBListGroup>
          <div className={styles.menubar}>
            <MDBNavbar expand="lg" className={styles.mdbNavbar}>
              <MDBNavbarToggler
                className={styles.mdbNavbarToggler}
                onClick={this.toggleCollapse("navbarCollapse3")}
              >
                <i className="fas fa-bars" />
              </MDBNavbarToggler>
              <MDBCollapse
                className={styles.mdbCollapse}
                id="navbarCollapse3"
                isOpen={this.state.collapseID}
                navbar
              >
                <MDBNavbarNav
                  className={cx(
                    styles.mdbNavbarNav,
                    styles["mdbNavbarNav_" + partnerId]
                  )}
                >
                  {renderMenu}
                </MDBNavbarNav>
              </MDBCollapse>
            </MDBNavbar>
          </div>
          <div>
            <div
              className={styles.mobile}
              onClick={() => this.handleOpenMenu(true)}
            >
              <i className="fas fa-bars" />
            </div>
            <Drawer
              isDrawer={this.state.openMenu}
              handleToggle={() => this.handleOpenMenu(false)}
            />
          </div>
        </MDBContainer>
      </>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated, info: infoUser },
    notification,
    global
  } = state;
  return {
    global,
    IsAuthenticated,
    notification,
    infoUser
  };
};

export default connect(mapStateToProps, {
  redirectToMedproId,
  checkReadNoti,
  selectMedicalBill,
  selectPatientFromList,
  logOut
})(withRouter(Header));

// {partnerId === "medpro" && (
//   <MDBListGroupItem>
//     <Link
//       to={{
//         pathname: "/clinic"
//       }}
//       replace={this.props.location.pathname === "/"}
//       className={cx(styles.button, styles.clinic)}
//     >
//       Quản lý phòng mạch
//     </Link>
//   </MDBListGroupItem>
// )}
